var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('sw-header'),_c('div',{staticClass:"app-con"},[_c('router-view')],1),_c('sw-right-nav',{on:{"onConsult":_vm.onConsult}}),_c('sw-footer'),_c('min-phone-nav',{on:{"onConsult":_vm.onConsult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }